import React, { useState } from 'react'

import { QA } from '@hozana/tests/constants'
import { TRACKING_SOURCE, UTM } from '@hozana/tracking/constants'

import { Cell } from 'elements/layout/Cell'
import { Div } from 'elements/layout/Div'
import { Row } from 'elements/layout/Row'
import { ScrollDiv } from 'elements/layout/ScrollDiv'

import { ShareContacts } from 'modules/share/components/ShareContacts'
import { ShareCopy } from 'modules/share/components/ShareCopy'
import { ShareCount } from 'modules/share/components/ShareCount'
import { ShareMore } from 'modules/share/components/ShareMore'
import { ShareProvider, TShareProviderProps } from 'modules/share/components/ShareProvider'
import { ShareSocial } from 'modules/share/components/ShareSocial'
import { SHARE_OBJECTS, SHARE_TYPES } from 'modules/share/constants'

export type TCommunitySharesMobileProps = Pick<TShareProviderProps, 'community'>

export const CommunitySharesMobile: TFC<TCommunitySharesMobileProps> = ({ community }) => {
  const [isExpandedShareCopy, expandShareCopy] = useState(false)

  return (
    <ShareProvider
      objectToShare={SHARE_OBJECTS.COMMUNITY}
      trackingSource={TRACKING_SOURCE.COMMUNITY_SIDEBAR}
      community={community}
      utmContent={UTM.CONTENT.COMMUNITY_PAGE_SHARE_BUTTON}
    >
      {!community.isPrivate && (
        <Div p="5px 1em">
          <ShareCount counts={community.sharesCount} fontSize="1em" lineHeight="1em" />
        </Div>
      )}
      <Div align="middle" h={{ xs: '50px', sm: 'auto' }} data-testid={QA.COMMUNITY_PAGE.SHARE_BLOCK}>
        <ScrollDiv overflowX="auto" overflowY="hidden" flex="1" p="0 0 0 1em">
          <Row align="middleLeft" nowrap>
            <Cell
              flex="1"
              align="middleLeft"
              p={{ xs: '5px 30px 5px 5px !important', sm: '0px !important' }}
              m="0 0 0 -5px"
            >
              {!isExpandedShareCopy && (
                <>
                  <ShareSocial
                    shareTypes={[
                      SHARE_TYPES.WHATSAPP,
                      SHARE_TYPES.FACEBOOK,
                      SHARE_TYPES.MESSENGER,
                      SHARE_TYPES.PINTEREST,
                    ]}
                  />
                  <ShareContacts />
                </>
              )}
              <ShareCopy m="3px 6px" onShare={() => expandShareCopy(false)} onExpand={() => expandShareCopy(true)} />
              {!isExpandedShareCopy && <ShareMore />}
            </Cell>
          </Row>
        </ScrollDiv>
      </Div>
    </ShareProvider>
  )
}
